import { createAsyncThunk } from '@reduxjs/toolkit';

import { driverAPI } from '@/modules/driver/api';
import { namespace } from '@/modules/driver/namespace';

import { updateMyDriver } from '../actions';

interface IParams {
  driverId: string;
  reason: string;
  message: string;
}

const blockDriver = createAsyncThunk(
  `${namespace}/block-driver`,
  async ({ driverId, reason, message }: IParams, { dispatch }) => {
    const driver = await driverAPI.blockDriver(driverId, reason, message);

    if (driver) {
      dispatch(updateMyDriver(driver));
    }

    return driver;
  },
);

export { blockDriver };
